var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9854",
    "data-name": "Group 9854",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5460"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#31e5e5",
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5672",
    "data-name": "Rectangle 5672",
    width: 297.181,
    height: 320.295,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5525",
    "data-name": "Rectangle 5525",
    width: 512,
    height: 512,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10118",
    "data-name": "Group 10118",
    transform: "translate(-212 -2641)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5460-2",
    "data-name": "Rectangle 5460",
    width: 492,
    height: 492,
    rx: 246,
    transform: "translate(222 2651)",
    fill: "#3a5686",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 212, 2641)",
    filter: "url(#Rectangle_5460)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5460-3",
    "data-name": "Rectangle 5460",
    width: 492,
    height: 492,
    rx: 246,
    transform: "translate(10 10)",
    fill: "#fff",
    opacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10114",
    "data-name": "Group 10114",
    transform: "translate(321.06 2736.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10113",
    "data-name": "Group 10113",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6997",
    "data-name": "Path 6997",
    d: "M57.355,74.16l73.568,25.165V126.86c0,.7-2.99,2.922-4.195,2.421-.983.058-3.351-1.948-3.351-2.421V103.6L49.809,78.435V53.746a5.181,5.181,0,0,1,7.546,0Z",
    transform: "translate(128.313 135.883)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6998",
    "data-name": "Path 6998",
    d: "M13.413,99.077l73.435-25.3.261-20.147,1.416-1.418,4.924,0c1.42.891,1.434,20.082,1.13,23.181-.157,1.594.125,3.174-1.409,4.282L20.959,103.351v23.264c0,.469-2.367,2.478-3.351,2.417-1.205.505-4.195-1.724-4.195-2.417Z",
    transform: "translate(34.553 136.128)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    d: "M41.9,53.7c.629-2.042,6.466-2.132,7.546,0v73.113c0,.473-2.367,2.482-3.351,2.42-1.205.505-4.195-1.724-4.195-2.42Z",
    transform: "translate(107.931 135.927)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    d: "M23.525,0V194.291h50.23V83.744h32.793V0Zm14,16.825a3.228,3.228,0,0,1,3.211-3.243H56.5a3.228,3.228,0,0,1,3.211,3.243v15.9A3.226,3.226,0,0,1,56.5,35.965H40.74a3.226,3.226,0,0,1-3.211-3.243Zm0,33.592a3.226,3.226,0,0,1,3.211-3.243H56.5a3.226,3.226,0,0,1,3.211,3.243v15.9A3.228,3.228,0,0,1,56.5,69.557H40.74a3.228,3.228,0,0,1-3.211-3.243Zm0,33.588a3.225,3.225,0,0,1,3.211-3.239H56.5A3.225,3.225,0,0,1,59.715,84v15.9a3.225,3.225,0,0,1-3.211,3.239H40.74a3.225,3.225,0,0,1-3.211-3.239Zm23.838,91.168a3.467,3.467,0,0,1-3.455,3.485H40.98a3.467,3.467,0,0,1-3.451-3.485V158.091a3.466,3.466,0,0,1,3.451-3.481H57.913a3.467,3.467,0,0,1,3.455,3.481Zm0-36.088a3.467,3.467,0,0,1-3.455,3.481H40.98a3.466,3.466,0,0,1-3.451-3.481V122a3.467,3.467,0,0,1,3.451-3.485H57.913A3.467,3.467,0,0,1,61.367,122ZM66.71,32.722v-15.9a3.228,3.228,0,0,1,3.211-3.243H85.685A3.228,3.228,0,0,1,88.9,16.825v15.9a3.226,3.226,0,0,1-3.211,3.243H69.921a3.226,3.226,0,0,1-3.211-3.243M92.719,66.905a3.467,3.467,0,0,1-3.455,3.481H72.332a3.466,3.466,0,0,1-3.451-3.481V49.825a3.469,3.469,0,0,1,3.451-3.485H89.264a3.47,3.47,0,0,1,3.455,3.485Z",
    transform: "translate(60.603 -0.001)",
    fill: "#0071af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    d: "M68.7,92.9H47.118V47.981a9.056,9.056,0,0,1,9.015-9.094h3.555A9.056,9.056,0,0,1,68.7,47.981Z",
    transform: "translate(121.381 101.39)",
    fill: "#0071af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    d: "M43.1,151.632a43.474,43.474,0,1,1,43.1-43.472A43.649,43.649,0,0,1,73.568,138.9,42.605,42.605,0,0,1,43.1,151.632",
    transform: "translate(0 168.662)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    d: "M18.614,69.778c17.652-2.413,19.3,23.094,3.851,24.717-16.9,1.775-18.453-22.733-3.851-24.717",
    transform: "translate(22.257 181.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    d: "M7.868,97.483A2.273,2.273,0,0,1,5.64,94.9C7,84.619,16.458,77.35,28.756,77.35c16.01,0,21.317,11.731,22.791,17.355a2.235,2.235,0,0,1-2.171,2.778Z",
    transform: "translate(14.476 201.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    d: "M73.1,151.632a43.474,43.474,0,1,1,43.1-43.472A43.649,43.649,0,0,1,103.568,138.9,42.605,42.605,0,0,1,73.1,151.632",
    transform: "translate(77.283 168.662)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    d: "M48.614,69.778c17.652-2.413,19.3,23.094,3.851,24.717-16.9,1.775-18.453-22.733-3.851-24.717",
    transform: "translate(99.54 181.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    d: "M37.868,97.483A2.273,2.273,0,0,1,35.64,94.9C37,84.619,46.458,77.35,58.756,77.35c16.01,0,21.317,11.731,22.791,17.355a2.235,2.235,0,0,1-2.171,2.778Z",
    transform: "translate(91.759 201.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    d: "M102.1,151.632A43.289,43.289,0,1,1,132.568,138.9,42.605,42.605,0,0,1,102.1,151.632",
    transform: "translate(151.99 168.662)",
    fill: "#4195c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    d: "M77.614,69.778c17.652-2.413,19.3,23.094,3.851,24.717-16.9,1.775-18.453-22.733-3.851-24.717",
    transform: "translate(174.247 181.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7010",
    "data-name": "Path 7010",
    d: "M66.868,97.483A2.273,2.273,0,0,1,64.64,94.9C66,84.619,75.458,77.35,87.756,77.35c16.01,0,21.317,11.731,22.79,17.355a2.235,2.235,0,0,1-2.171,2.778Z",
    transform: "translate(166.466 201.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7011",
    "data-name": "Path 7011",
    d: "M39.2,25.073V128.921h21.9v-44.1A16.1,16.1,0,0,1,77.121,68.65h2.4A16.1,16.1,0,0,1,95.548,84.818v44.1h24.6V25.073ZM72.368,53.351a3.467,3.467,0,0,1-3.455,3.481H51.981a3.466,3.466,0,0,1-3.451-3.481V36.27a3.469,3.469,0,0,1,3.451-3.485H68.913a3.47,3.47,0,0,1,3.455,3.485Zm35.632,0a3.467,3.467,0,0,1-3.455,3.481H87.613a3.466,3.466,0,0,1-3.451-3.481V36.27a3.469,3.469,0,0,1,3.451-3.485h16.933A3.47,3.47,0,0,1,108,36.27Z",
    transform: "translate(100.973 65.373)",
    fill: "#0071af"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporates);
export default __webpack_public_path__ + "static/media/Corporates.147ddb6fa1440db6653bf50d80ccbbd1.svg";
export { ForwardRef as ReactComponent };